import { render, staticRenderFns } from "./GiftReviews.vue?vue&type=template&id=5d4ef18c&scoped=true&"
import script from "./GiftReviews.vue?vue&type=script&lang=ts&"
export * from "./GiftReviews.vue?vue&type=script&lang=ts&"
import style0 from "./GiftReviews.vue?vue&type=style&index=0&id=5d4ef18c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ef18c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5d4ef18c', component.options)
    } else {
      api.reload('5d4ef18c', component.options)
    }
    module.hot.accept("./GiftReviews.vue?vue&type=template&id=5d4ef18c&scoped=true&", function () {
      api.rerender('5d4ef18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/gifts/paywall/GiftReviews.vue"
export default component.exports